import styled from 'styled-components';

export const StyledAboutOverview = styled.section`
    padding: 200px 0 200px;
    position: relative;
    background: #e0f4fd;
    background-image: url('/images/static/about.jpg');
    background-position: bottom right;
    background-repeat: no-repeat;
    overflow: hidden;

    .fixed-right {
        position: absolute;
        right: ${props => props.offset || 90}px;
        bottom: 0;
        z-index: -1 !important;
    }

    .fixed-left {
        position: absolute;
        left: ${props => props.offset || 90}px;
        top: 0;
        z-index: -1 !important;
    }

    .content {
        padding-left: 10%;

        p {
            font-weight: 400;
            font-size: 1rem;
            line-height: 1.5rem;
            letter-spacing: 0;
        }
    }

    .video_tour {
        position: relative;
        top: 38%;
    }

    @media (max-width: 767px) {
        padding: 120px 0;

        .content {
            padding-left: 0;
        }

        .video_tour {
            top: 0;
            margin-top: 60px;
        }

        .title {
            margin-bottom: 60px;

            h3 {
                font-weight: 500;
                font-size: 1.75rem !important;
                line-height: 2rem !important;
                letter-spacing: 0em !important;
            }
        }
    }
`;